<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - ROM基地</div>
        <product-menu now="product" />
        <div class="v100 bigimg mt20">
            <img alt="ROM基地" src="@/assets/images/P3.jpg" />
            <div class="brand">
				<img src="@/assets/images/romjd.jpg" alt="ROM基地" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">ROM基地</h1>
            <!-- <dl>
                <dt></dt>
                <dd id="B1">
                    <a href="http://www.romjd.com" target="_blank">立即访问</a></dd>
            </dl> -->
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="ROM基地，海量ROM，移植、美化、定制、精简，特色风格ROM全面覆盖" class="fl" src="@/assets/images/Ray6.jpg" />
                <dt class="fr">海量ROM</dt>
                <dd class="fr">
                    汇聚各大ROM团队、ROMer制作的ROM，移植、美化、定制、精简，特色风格ROM全面覆盖</dd>
            </dl>
            <dl>
                <img alt="ROM基地，与MIUI、百度云、乐蛙、乐众、点心等ROM团队合作" class="fr" src="@/assets/images/Ray7.jpg" />
                <dt class="fl">合作专区</dt>
                <dd class="fl">
                    与MIUI、百度云、乐蛙、乐众、点心等第三方深度定制ROM团队合作</dd>
            </dl>
            <dl>
                <img alt="ROM基地，小编亲测ROM，不定期推荐口碑好的rom" class="fl" src="@/assets/images/Ray8.jpg" />
                <dt class="fr">亲测推荐</dt>
                <dd class="fr">
                    小编亲测ROM，不定期推荐口碑好的rom，直观的数据，让您用上优质ROM</dd>
            </dl>
            <dl>
                <img alt="ROM基地，安全、无毒、无暗扣的ROM绿色安全" class="fr" src="@/assets/images/Ray9.jpg" />
                <dt class="fl">绿色安全</dt>
                <dd class="fl">
                    安全、无毒、无暗扣的ROM，让您刷机更舒心</dd>
            </dl>
        </div>
    </div>
</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "romjd",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/romjd.vue